import { useCallback } from 'react'
import { useLocation } from 'react-router'

import { useRoute } from '../../../hooks/useRoute'
import { BackButton } from '../../UI/BackButton'

export const Navigation = () => {
    const { navVisits } = useRoute()
    const { pathname } = useLocation()

    const onBack = useCallback(() => {
        if (pathname.startsWith('/settings/billing/update') || pathname.startsWith('/settings/templates/')) {
            window.history.back()
        } else {
            navVisits()
        }
    }, [pathname, navVisits])

    return (
        <div className="block sm:flex sm:items-center mb-6">
            <BackButton onNavigateBack={onBack} />
            <PageTitle />
        </div>
    )
}

const pageTitle: Record<string, string> = {
    '/settings/account': 'Settings',
    '/settings/templates': 'Templates',
    '/settings/templates/new': 'New template',
    '/settings/templates/id': 'Update template',
    '/settings/billing': 'Billing',
    '/settings/billing/update': 'Choose your avaros.ai plan',
    '/settings/billing/checkout': 'Checkout',
    '/settings/referral': 'Referral',
    '/settings/developer': 'Developer',
    '/settings/request-feature': 'Request a feature'
}

const PageTitle = () => {
    let { pathname } = useLocation()
    pathname = pathname.replace(/\/checkout\/.*/, '/checkout')
    pathname = pathname.replace(/\/templates\/(?!new).*$/, '/templates/id')

    return <div className="text-xl font-medium flex items-center">{pageTitle[pathname]}</div>
}
